import { render, staticRenderFns } from "./SuperadminBanner.vue?vue&type=template&id=08f53273&scoped=true"
import script from "./SuperadminBanner.vue?vue&type=script&lang=js"
export * from "./SuperadminBanner.vue?vue&type=script&lang=js"
import style0 from "./SuperadminBanner.vue?vue&type=style&index=0&id=08f53273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f53273",
  null
  
)

export default component.exports